import { render, staticRenderFns } from "./spreadifyTableWrapper.vue?vue&type=template&id=32fabb95&"
import script from "./spreadifyTableWrapper.vue?vue&type=script&lang=js&"
export * from "./spreadifyTableWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports